module.exports = __webpack_public_path__ + "static/media/cowbell-more.98217f67.svg";